/* eslint-disable graphql/template-strings */
import fetch from 'node-fetch';
import { apiUrl } from 'config';

const prepareMutation =
  ' mutation($imageType: PrepareUploadImageFormImageType!) { ' +
  'prepareUploadImage(input:{imageType: $imageType}){ ' +
  '  url, method, fields { googleAccessId, ' +
  '  signature, key, policy, successActionStatus' +
  '}}}';

/**
 * @description
 * Function called by uppy AWS3 plugin for get a signed url.
 *
 * @param {string} imageType - Enum with two possible
 * values (AD_IMAGE, USER_IMAGE).
 * @returns {undefined} No return.
 */
const prepareImageUpload = imageType =>
  // Send a request to our signing endpoint.
  fetch(apiUrl, {
    method: 'post',
    // Send and receive JSON.
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
    body: JSON.stringify([
      {
        operationName: null,
        query: prepareMutation,
        variables: {
          imageType,
        },
      },
    ]),
  })
    .then(response => response.json())
    .then(data => ({
      method: data[0].data.prepareUploadImage.method,
      url: data[0].data.prepareUploadImage.url,
      fields: {
        GoogleAccessId: data[0].data.prepareUploadImage.fields.googleAccessId,
        signature: data[0].data.prepareUploadImage.fields.signature,
        key: data[0].data.prepareUploadImage.fields.key,
        policy: data[0].data.prepareUploadImage.fields.policy,
        success_action_status:
          data[0].data.prepareUploadImage.fields.successActionStatus,
      },
    }));

export default prepareImageUpload;
